<template>
  <div id="about">
    <nav-dom></nav-dom>
    <div class="about-content">
      <div v-html="company"></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import NavDom from '@/components/navtop/navloginbefore'
export default {
  name: 'About',
  data() {
    return {
      company: ''
    }
  },
  created () {
    this.getConpy();
  },
  methods: {
    getConpy() {
      let _this = this;
      _this.$http({
        method: 'get',
        url: _this.$api + '/sys/company'
      }).then((response) => {
        if(response.data.code == 200) {
          _this.company = response.data.data;
        }
      })
    }
  },
  components: {
    NavDom
  }
}
</script>

<style lang="stylus" scoped>
  .about-content
    position relative
    margin 20px
    padding 60px 40px 20px 40px
    background #f8f8f8
    box-shadow 3px 3px 3px #f5f5f5 inset
</style>





// WEBPACK FOOTER //
// src/components/about/about.vue